import type { TaxTypeApi, UsTaxTypeApi } from 'api-typings/common/common';

/**
 * User tax information collection model
 */
export interface UserTaxInfo {
  readonly id: number;
  readonly countryCode: string;
  readonly type: TaxTypeApi;
  readonly usTaxSubtype?: UsTaxTypeApi;
  readonly number: string;
  readonly name?: string;
}

// Custom region with taxations
export enum UserTaxRegion {
  EU = 'EU',
  IN = 'IN',
  MX = 'MX',
  US = 'US',
}
